import { Grid, Dialog, DialogTitle, DialogContent, IconButton, Divider, Tooltip, Typography } from '@mui/material';
import { List, ListItem, ListItemText } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useLoadData } from '../../hooks/useLoadData';
import { SkeletonIndicator } from '../../components/skeleton-indicator.component';
import { ApiResponse } from '../../models/api-response';
import { servicesApiKeyStore } from '../../api/masters/services-api-key-store';

interface ServicesDialogProps {
  customerID: number;
  isOpen: boolean;
  onCloseClick: () => void;
}

export const ServicesDialog = ({ customerID, isOpen, onCloseClick }: ServicesDialogProps) => {
  const { isLoading, data } = useLoadData<ApiResponse<any>>(servicesApiKeyStore.getServiceCustomerMappings(customerID));
  return (
    <Dialog
      open={isOpen}
      fullWidth={true}
      maxWidth={'md'}
      // onClose={onCloseClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">SERVICES</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCloseClick}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers className="popupDilog">
        <SkeletonIndicator isLoading={isLoading} count={3} variant="h4" />
        <List sx={{ width: '100%', maxHeight: '500px' }}>
          {data &&
            data.data.map((item: any, index: any) => (
              <>
                <ListItem key={`${item.serviceID}-${item.serviceName}`}>
                  <ListItemText
                    primary={
                      <Grid container direction="row" spacing={2}>
                        <Grid item>{index + 1}</Grid>
                        <Grid item>{item.serviceName}</Grid>
                      </Grid>
                    }
                  />
                </ListItem>
                <Divider />
              </>
            ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};
